import { useEffect } from 'react'

export const useTableScroll = (activities: any) => {
  const pageElement = document.getElementById('page')
  const tableBody = document.querySelector('.ant-table-body') as HTMLDivElement

  useEffect(() => {
    if (!tableBody) return

    tableBody.style.overflow = 'scroll hidden'

    const onscroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight

      if (scrollTop + clientHeight >= scrollHeight - 1 && tableBody) {
        tableBody.style.overflow = 'auto scroll'
      } else {
        tableBody.style.overflow = 'scroll hidden'
      }
    }

    window.addEventListener('scroll', onscroll)

    return () => {
      window.removeEventListener('scroll', onscroll)
    }
  }, [tableBody, activities])

  useEffect(() => {
    if (pageElement) {
      pageElement.style.height = 'auto'
      pageElement.style.maxHeight = 'unset'
    }

    return () => {
      if (pageElement) {
        pageElement.style.height = ''
        pageElement.style.maxHeight = 'unset'
      }
    }
  }, [pageElement])
}
